import React from "react";

export const ContextSetting = React.createContext<{ supplierSetting: any }>({
  supplierSetting: {
    enabledChat: false,
  },
});
